var translation = {
	Navatar: {
		header: "AWS プロファイル",
		subheader: "プロファイルを利用すると、一部の AWS エクスペリエンスで操作が向上します。",
		profileButtonText: "プロファイルを表示",
		logOutText: "ログアウト",
		logInText: "ログイン",
		createProfileText: "プロフィールを作成",
		federateLoginModalTitle: "Midway を使用して AWS プロファイルにアクセスする",
		federateLoginModalFirstDescription: "Midway を使用して AWS プロファイルにアクセスすることが Amazon の従業員には推奨されています。セキュリティを考慮したこの推奨方法により、内部システムとのシームレスな統合が可能になります。",
		federateLoginModalSecondDescription: "このメッセージが表示されているのは、AWS ビルダー ID を使用して Amazon のメールアドレスでログインしているためです。Midway に切り替えるか、現在のログインで続行することを選択するまで、ログインするたびにこのプロンプトが表示されます。",
		federateLoginModalPrimaryButton: "Midway でサインイン",
		federateLoginModalSecondaryButton: "AWS ビルダー ID で続行"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
